exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!bootstrap-slider/dist/css/bootstrap-slider.min.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js!gridforms/gridforms/gridforms.css"), "");

// module
exports.push([module.id, ".btn {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n.main-loading {\n  width: 100%;\n  z-index: 99999;\n  background: rgba(255, 255, 255, 0.4);\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  position: fixed;\n  color: var(--primary-color);\n  text-align: center;\n  padding: 20%;\n}\n.main-loading img {\n  height: 200px;\n}\n.main-loading p {\n  font-weight: bold;\n  font-size: 24px;\n  margin-top: 18px;\n}", ""]);

// exports
